<template>
  <section v-editable="blok" class="user-testimonial">
    <div class="user-testimonial__upper">
      <h4
        :class="[
          'user-testimonial__title',
          {
            'user-testimonial__title--no-img': !hasImg,
          },
        ]"
      >
        {{ blok.title }}
      </h4>
      <BaseNuxtImage
        v-if="hasImg"
        class="user-testimonial__image"
        :src="(blok.image && blok.image.filename) || '/'"
        :alt="blok.image && blok.image.alt"
      />
    </div>
    <StoryblokComponent
      v-for="childBlok in blok.content"
      :key="childBlok._uid"
      :blok="childBlok"
    />
  </section>
</template>

<script lang="ts" setup>
import type { SbBlogUserTestimonial } from '@/types'

interface Props {
  blok: SbBlogUserTestimonial
}

const props = defineProps<Props>()

const hasImg = computed(() => !!props.blok.image && !!props.blok.image.filename)
</script>

<style lang="scss" scoped>
.user-testimonial {
  padding: 40px;
  background-color: var(--yellow-100);
  border-radius: 16px;

  @media (min-width: $breakpoint-md) {
    padding: 48px;
  }

  &__upper {
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 36px;

    @media (min-width: $breakpoint-md) {
      flex-direction: row;
      justify-content: space-between;
      margin-bottom: 24px;
    }
  }

  &__image {
    width: 100%;
    max-width: 176px;
    height: 100%;
    margin-bottom: 40px;

    @media (min-width: $breakpoint-md) {
      margin-bottom: 0;
      max-width: 220px;
    }
  }

  &__title {
    @include heading-5;

    margin-top: 0;
    margin-bottom: 0;
    max-width: 290px;

    @media (min-width: $breakpoint-md) {
      @include heading-4;

      margin-top: 125px;
    }

    &--no-img {
      @media (min-width: $breakpoint-md) {
        margin-top: 0;
      }
    }
  }
}
</style>
